export default __webpack_public_path__ + "static/media/multi_color_star_2.c35e88ef.svg";